import React from 'react';
import { Text, View } from "react-native";
import { styles } from "./SafetyDescriptionViewStyle";
import { TranslationView } from "@levelapp/softfabric-ui";
import Project from "../../../../../Common/DTO/Project";
import Helpers from "../../../../../Common/Helpers/AmountHelpers";
import { useWindowSizeContext } from "../../../../../Common/contexts/WindowSizeContext";

interface SafetyDescriptionViewProps {
    project: Project;
}

export default function SafetyDescriptionView({ project }: SafetyDescriptionViewProps) {

    const { isMobile } = useWindowSizeContext();

    const fontSize = isMobile ? 10 : 12;
    const boxTitleFontSize = fontSize * 1.33;

    var safetyDescription: string | undefined = Helpers.getPropertyValue("SAFETY_DESCRIPTION", project.projectPropertyValues);

    if (safetyDescription === undefined || safetyDescription.length === 0)
        safetyDescription = Helpers.getPropertyValue("SAFETY", project.projectPropertyValues);

    if (safetyDescription === undefined || safetyDescription.length === 0) return null;

    return (
        <View style={[styles.page]}>
            <TranslationView style={[styles.title]}>safety.description</TranslationView>
            <Text style={[styles.text, { fontSize: boxTitleFontSize }]}>{safetyDescription}</Text>
        </View>
    );
}